import * as yup from "yup";
import { GetSecurityTokenValidator } from "app/validation/securityTokenValidator";
export const Validate = (requiresMfa) => {
    const schema = yup
        .object({
        ProfileId: yup.string(),
        SMSNotificationStatus: yup.boolean(),
        EmailNotificationStatus: yup.boolean(),
        StatementNotificationStatus: yup.boolean(),
        TwoFactorToken: GetSecurityTokenValidator(requiresMfa),
    })
        .defined();
    return schema;
};
